<template>
  <div v-if="tableData.length != 0">
    <el-table
      :data="tableData"
      stripe
      header-align="center"
      :header-cell-style="{
        color: '#ffffff',
        fontSize: '14px',
        backgroundColor: '#011946'
      }"
    >
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column prop="infoId" label="信息ID" align="center">
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" align="center">
      </el-table-column>
      <el-table-column prop="street" label="街道" align="center">
      </el-table-column>
      <el-table-column prop="nickName" label="用户昵称" align="center">
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center">
      </el-table-column>
      <el-table-column label="信息状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">待审核</span>
          <span v-if="scope.row.status == 3">被举报</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleClick(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryParam.pageNum"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="queryParam.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="text-align: center;"
    >
    </el-pagination>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="detailVisible"
      width="50%"
      :before-close="cancel"
    >
      <el-form label-width="0px">
        <el-form-item>
          <div style="line-height:25px">{{ dialogInfo }}</div></el-form-item
        >
        <el-form-item>
          <el-row style="text-align: center;">
            <div v-for="(url, index) in imageList" :key="index">
              <el-col
                :span="8"
                style="border: 1px solid #333; margin-right:-1px; margin-bottom:-1px;"
              >
                <el-image
                  :src="url"
                  style="max-width: 30%;max-height: 30%;"
                  :preview-src-list="imageList"
                ></el-image>
              </el-col>
            </div>
          </el-row>
        </el-form-item>

        <el-form-item>
          <el-row>
            <el-col :span="12">
              <el-radio-group v-model="status" size="mini">
                <el-radio-button label="2">通 过</el-radio-button>
                <el-radio-button label="4">不通过</el-radio-button>
              </el-radio-group>
            </el-col>
            <el-col :span="12">
              <el-select
                v-model="reason"
                placeholder="请选择"
                :disabled="status == 2"
                size="mini"
              >
                <el-option
                  v-for="item in reasonList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else class="elseDiv">
    小 城 十 月
  </div>
</template>
<script>
import Bus from "../api/Bus";
import { checkList, updateStatus } from "../api/api.js";
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      queryParam: {
        pageSize: 10,
        pageNum: 1,
        status: "0"
      },
      detailVisible: false,
      dialogTitle: "",
      dialogInfo: "",
      imageList: [],
      status: "3",
      reason: "",
      infoId: "",
      reasonList: [
        { value: "涉黄信息", label: "涉黄信息" },
        { value: "有害信息", label: "有害信息" },
        { value: "网络暴力", label: "网络暴力" },
        { value: "人身攻击", label: "人身攻击" },
        { value: "违法信息", label: "违法信息" },
        { value: "不实信息", label: "不实信息" },
        { value: "其他", label: "其他" }
      ]
    };
  },
  methods: {
    cancel() {
      this.detailVisible = false;
      this.status = "4";
      this.reason = "";
      this.infoId = "";
    },
    save() {
      let param = {
        status: this.status,
        reason: this.status == 2 ? "" : this.reason,
        infoId: this.infoId
      };
      updateStatus(param).then(res => {
        this.detailVisible = false;
        this.queryList();
      });
    },
    handleClick(row) {
      this.detailVisible = true;
      this.dialogTitle = row.nickName;
      this.dialogInfo = row.releaseInfo;
      this.imageList = [];
      this.infoId = row.infoId;
      // row.picturesUrl.forEach(element => {
      //   this.imageList.push("http://elejog.com:18090/agri" + element);
      // });
      this.imageList = row.picturesUrl;
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.queryList();
    },
    queryList() {
      checkList(this.queryParam).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    }
  },
  mounted() {
    Bus.$on("asideStatus", content => {
      this.queryParam.status = content;
      this.queryList();
    });
  }
};
</script>
<style>
.elseDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 40px;
  font-style: italic;
  font-weight: bold;
}
.el-table tr {
  background-color: #d66fff !important;
  color: #000;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/dhome/DMain.vue